import { render } from "./ImageRectOutline.vue?vue&type=template&id=8326742e&scoped=true&ts=true"
import script from "./ImageRectOutline.vue?vue&type=script&lang=ts"
export * from "./ImageRectOutline.vue?vue&type=script&lang=ts"

import "./ImageRectOutline.vue?vue&type=style&index=0&id=8326742e&lang=scss&scoped=true"

import exportComponent from "E:\\Code\\Github\\Wuguojie-AviationTeach\\AviationTeach-PPT\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8326742e"]])

export default __exports__